'use client';

import { useGeoContext } from '../contexts/GeoProvider';
import useFeatureFlag from './useFeatureFlag';

const PARTICIPATING_COUNTRIES = ['US', 'CA'];

const useDisplayBestBuy = (): boolean => {
  const enabled = useFeatureFlag('show-best-buy');
  const { countryData } = useGeoContext();
  const countryCode = countryData?.countryCode;

  return enabled && PARTICIPATING_COUNTRIES.includes(countryCode!);
};

export default useDisplayBestBuy;
